<template>
  <div style="text-align:-webkit-center">
    <b-carousel
      ref="myCarousel"
      id="carousel-no-animation"
      style="text-shadow: 0px 0px 2px #000;width:auto;height:480px"
      no-animation
      controls
      indicators
      background="#ababab"
    >
      <!-- Text slides with image -->
      <div v-for="(photo, index) in photos" :key="index">
        <b-carousel-slide :img-src="photo.photoUrl"> </b-carousel-slide>
      </div>
    </b-carousel>
    <b-row class="padding-two-top">
      <!-- <b-col lg="6" class="padding-left-none">
        <b-button
          class="width-100 bg-white btn-white-v border-black-all color-gray"
          @click="$bvModal.hide('modal-carousel')"
        >
          Cerrar
        </b-button>
      </b-col> 
      <b-col lg="6" class="padding-rigth-none">
        <b-button
          class="btn-dark width-100"
          @click="next"
        >
          Siguiente
        </b-button>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  props: {
    photos: {
      type: Array,
    },
  },
  methods: {
    next() {
      this.$refs.myCarousel.next();
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
::v-deep .carousel-item {
  width: 500px;
  height: 480px;
  margin-right: auto !important;
  margin-left:  auto !important;
  float: none !important;
}
::v-deep .d-block{
  display: initial !important;
}
 ::v-deep .carousel-item img {
  height: 480px;
  width: auto !important;
}
.btn-white-v:hover {
  color: white !important;
  background: #626262 !important ;
}
 ::v-deep .modal-title{
  margin-left:auto;
}
::v-deep #modal-carousel___BV_modal_title_{
  margin-left: auto;
}
h5{
  margin-left:auto;
}
</style>
